import { UseQueryExecute } from 'urql';
import { useTechnicalMessages } from '../useTechnicalMessages';
import { useEffect, useState } from 'react';

export const useRefetchTrigger = ({ refetch }: { refetch: UseQueryExecute }) => {
  // this is meant to only trigger a reload, when the count changes.
  const { technicalMessages } = useTechnicalMessages();
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (technicalMessages.length !== count) {
      setCount(technicalMessages.length);
      refetch({ requestPolicy: 'cache-and-network' });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [technicalMessages]);
};
